import instance from "./api";
import { AxiosResponse } from 'axios';
import { IOrder } from "../helpers/types";

export default class OrdersService {
    static async findAll(params: any): Promise<AxiosResponse<any>> {
        return instance.get('orders', { params });
    }

    static async findOne(orderID: number): Promise<AxiosResponse<IOrder>> {
        return instance.get<IOrder>(`orders/${orderID}` )
    }

    static async create(order: FormData): Promise<AxiosResponse<IOrder>> {
        return instance.post<IOrder>(`orders`, order)
    }

    static async update(orderData: any, orderID: number): Promise<AxiosResponse<IOrder>> {
        return instance.put<IOrder>(`orders/${orderID}`, orderData)
    }

    static async delete(orderID: number): Promise<AxiosResponse<IOrder>> {
        return instance.delete<IOrder>(`orders/${orderID}`)
    }

    static async getGlobalUnreadCount(): Promise<AxiosResponse<number>> {
        return instance.get<number>('orders/unread/count');
    }
}